
import { createBrowserRouter } from "react-router";
import ErrorPage from "@/pages/ErrorPage";

import { App } from "@/App";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: App,
    errorElement: <ErrorPage />,
    children: [
      // structural pages: homepage, login, profile, about
      {
        index: true,
        async lazy() {
          const { default: Component } = await import("@/pages/Home");
          return { Component };
        },
      },
      {
        path: "login",
        async lazy() {
          const { default: Component } = await import("@/pages/user/Login");
          return { Component };
        },
      },
      {
        path: "user-assignments",
        async lazy() {
          const { default: Component } = await import("@/pages/UserAssignments");
          return { Component };
        },
      },
      {
        path: "profile/:userId?",
        async lazy() {
          const { default: Component } = await import("@/pages/user/Profile");
          return { Component };
        },
      },
      {
        path: "nudges",
        async lazy() {
          const { default: Component } = await import("@/pages/user/Nudges");
          return { Component };
        },
      },
      {
        path: "about",
        async lazy() {
          const { default: Component } = await import("@/pages/About");
          return { Component };
        },
      },

      // project and task management
      {
        path: "projects",
        async lazy() {
          const { default: Component } = await import("@/pages/projects/Projects");
          return { Component };
        },
      },
      {
        path: "projects/new",
        async lazy() {
          const { default: Component } = await import("@/pages/projects/CreateProject");
          return { Component };
        },
      },
      {
        path: "projects/:projectId",
        async lazy() {
          const { default: Component } = await import("@/pages/projects/ProjectDetails");
          return { Component };
        },
      },
      {
        path: "projects/:projectId/edit",
        async lazy() {
          const { default: Component } = await import("@/pages/projects/EditProject");
          return { Component };
        },
      },
      {
        path: "projects/:projectId/tasks/new",
        async lazy() {
          const { default: Component } = await import("@/pages/tasks/CreateTask");
          return { Component };
        },
      },
      {
        path: "tasks/:taskId/review",
        async lazy() {
          const { default: Component } = await import("@/pages/tasks/ReviewTask");
          return { Component };
        }
      },
      {
        path: "tasks/:taskId/discuss",
        async lazy() {
          const { default: Component } = await import("@/pages/tasks/DiscussTask");
          return { Component };
        }
      },
      {
        path: "tasks/:taskId/edit?",
        async lazy() {
          const { default: Component } = await import("@/pages/tasks/DoTask");
          return { Component };
        },
      },


      // test pages
      {
        path: "sandbox",
        async lazy() {
          const { default: Component } = await import("@/pages/testing/Sandbox");
          return { Component };
        },
      },
      {
        path: "toast-demo",
        async lazy() {
          const { default: Component } = await import("@/pages/testing/ToastDemo");
          return { Component };
        },
      },
      {
        path: "auth-test",
        async lazy() {
          const { default: Component } = await import("@/pages/testing/AuthTest");
          return { Component };
        },
      },
      {
        path: "modal-sidebar-demo",
        async lazy() {
          const { default: Component } = await import("@/pages/testing/ModalSidebarDemo");
          return { Component };
        },
      },
    ],
  },
]);
